/* eslint-disable jsx-a11y/anchor-has-content */
/**
 * TODO: Update this component to use your client-side framework's link
 * component. We've provided examples of how to do this for Next.js, Remix, and
 * Inertia.js in the Catalyst documentation:
 *
 * https://catalyst.tailwindui.com/docs#client-side-router-integration
 */

import * as Headless from "@headlessui/react";
import React, { forwardRef } from "react";

import GACLink from "../Link";

export const Link = forwardRef<HTMLAnchorElement, { href: string } & React.ComponentPropsWithoutRef<"a">>((props, ref) => (
  <Headless.DataInteractive>
    <GACLink to={props.href} ref={ref} {...props} />
  </Headless.DataInteractive>
));
